import { JOBS_CANDIDATE_PROFILE_PAGE, JOBS_NEW_MENU_TOOLTIP, POSTS_PAGE } from '@/constants';
import type { CurrentUser } from '@/types/';
import { getPortfolioPath } from '@/utils/routes';

export const ACADEMY_NEW_MENU_TOOLTIP = 'academy_new_menu_tooltip';
export const PP_NEW_MENU_TOOLTIP = 'public_portfolio_new_menu_tooltip';

export interface IMenuItem {
  label: string;
  icon: string;
  link: string;
  route?: string[];
  tooltip?: string;
  unreadCountLabel?: string;
  actionRequiredCountLabel?: string;
  isExternal?: boolean;
}

interface GetMenuItemsPayload {
  user: CurrentUser;
  unreadPostsMessage: string | null;
  hiringCount: number | null;
}

export function getMenuItems({ user, unreadPostsMessage, hiringCount }: GetMenuItemsPayload): IMenuItem[] {
  if (user?.slug) {
    const portfolioPath = getPortfolioPath(user.slug);

    return [
      {
        label: 'My Feed',
        icon: 'my_feed',
        link: '/war-room/posts/tab/my_feed',
        route: [POSTS_PAGE.path, '/war-room/categories', '/war-room/topics'],
        ...(unreadPostsMessage && { unreadCountLabel: unreadPostsMessage }),
      },
      {
        label: 'Jobs',
        icon: hiringCount ? 'jobs-unread' : 'jobs',
        link: JOBS_CANDIDATE_PROFILE_PAGE.path,
        route: [JOBS_CANDIDATE_PROFILE_PAGE.path, '/jobs/welcome', '/jobs/about'],
        tooltip: JOBS_NEW_MENU_TOOLTIP,
        ...(hiringCount && { actionRequiredCountLabel: String(hiringCount) }),
      },
      {
        label: 'My Portfolio',
        icon: 'portfolio',
        link: portfolioPath,
        route: [portfolioPath],
        tooltip: PP_NEW_MENU_TOOLTIP,
      },
      {
        label: 'Salaries',
        icon: 'salaries',
        link: '/salaries',
        isExternal: true,
      },
      Boolean(user.xperiencifyMagicLoginLink) && {
        label: 'Tech Sales U',
        icon: 'techsalesu',
        link: user.xperiencifyMagicLoginLink,
        isExternal: true,
      },
    ].filter(Boolean) as IMenuItem[];
  } else {
    return [
      {
        label: 'Feed',
        icon: 'my_feed',
        link: '/war-room/posts/tab/my_feed',
        route: [POSTS_PAGE.path, '/war-room/categories', '/war-room/topics'],
      },
      {
        label: 'Jobs',
        icon: 'jobs',
        link: '/jobs/welcome',
        route: ['/jobs', '/jobs/about'],
      },
      {
        label: 'Salaries',
        icon: 'salaries',
        link: '/salaries',
        route: ['/salaries'],
        isExternal: true,
      },
    ];
  }
}
